import "../styles/css/bootstrap.min.css";
import { useContext, useEffect, useState } from "react";
import Toast from 'react-bootstrap/Toast';
import logo from '../assets/logo/logo.jpg';
import Axios from "axios";
import PaysContext from "../contexts/payscontext";


function Postformulairepays(props) {
  const payscourant = useContext(PaysContext); //PaysContext
  const adminExiste = props.adminExiste

  
//eagrimet.online 
// const urlpost = "http://localhost:8000/eagrimetApi/paysBulletin/"; 
  const urlpost = "https://eagrimet.online/eagrimetApi/paysBulletin/";  
  const [error, setError] = useState(null);
  
  const [objRegion, setObjRegion] = useState({
    code: "",    
    sourceinfo: "",
    dateCreation: null,    
    alertMessage: "",
  });

  
  

  const[bulletinPdf, SetBulletinPdf] = useState("");
  const[bulletinImage, SetBulletinImage] =  useState("");
  const[bulletinAudio, SetBulletinAudio] = useState("");
  const[message, SetMessage] = useState("");
  const[btnvalider, SetBtnvalider] =  useState(false)
  const [showMsg, SetShowMsg] = useState(false);
  const [showform, SetShowForm ] = useState(true);
  const createMessage ="Ajout effectué avec Succès"  
  
  const toggleShowMsg = () => {SetShowMsg(false) } 
  const ouvreMsg = () => {SetShowMsg(true); SetBtnvalider(false)}

  

  function handle(e) {
    const newobjRegion = { ...objRegion };
    newobjRegion[e.target.id] = e.target.value;
    setObjRegion(newobjRegion);
    console.log(newobjRegion);
  }

  function effaceChamp() {
    setObjRegion({...objRegion, code: "",  sourceinfo: "", alertMessage: ""})
    
  }

  async function submit(e) {
    let axiosConfig = {
      headers : {
         "Content-Type": "multipart/form-data",
         
      }
    }


    const form = document.getElementById("form");
    e.preventDefault();
    const formdata = new FormData(form);

    // console.log([...formdata])
    formdata.append("code", payscourant);    
    formdata.append("sourceinfo", objRegion.sourceinfo);
    formdata.append("dateCreation", "");
    formdata.append("bulletinPdf", bulletinPdf);      
    formdata.append("bulletinImage",bulletinImage);  
    formdata.append("bulletinAudio",bulletinAudio);     
    formdata.append("alertMessage", objRegion.alertMessage);       
    formdata.append("pays", payscourant);

    console.log([...formdata]);

    Axios.post(
      urlpost,
      formdata, 
      axiosConfig      
    )
      .then((result) => {
        console.log(result.status);  
        ouvreMsg();
        effaceChamp(); 
          
       
      })
      .catch((err) => console.log(err));
      //window.location.reload();
      
  }


  if (adminExiste && props.modecreation) {

    //if(showform){

  return (    
    <div className="d-flex justify-content-center container p-2">  
     
        
      <form id="form" onSubmit={(e) => {submit(e)} } >        
      <h1>Creation Pays {payscourant} </h1>

          <div className='d-flex flex-row-reverse'>
            {showMsg && 
                <Toast show={showMsg} onClose={toggleShowMsg} >
                <Toast.Header className='bg-success'>
                    <img src={logo} className='rounded-circle' height={30}  alt=""/>
                    <strong>&nbsp; eAgrimet</strong>
                </Toast.Header>
                <Toast.Body>{createMessage} </Toast.Body>            
            </Toast>
            }
            
          </div>

      
        <div className="row">

        
        <div className="mb-4 col-3"> 
        <input
          placeholder="Source"
          type="text"
          id="sourceinfo"          
          onChange={(e) => handle(e)}
          className="form-control"
          value={objRegion.sourceinfo}
        />
        </div>
        </div>
        <div className="mb-4 col-6"> 
        <textarea
          placeholder="alertMessage"
          id="alertMessage"          
          onChange={(e) => handle(e)}
          className="form-control"
          value={objRegion.alertMessage}
        />
        </div>
        <div className="row">
        <div className="mb-4 col-4"> 
        <label for="bulletinPdf" className="form-label">PDF</label>
        <input
          placeholder="bulletinPdf"
          id="bulletinPdf"
          type="file"
          accept="application/pdf, .pdf" 
          onChange={(e) => {SetBulletinPdf(e.target.files[0]); SetBtnvalider(true)}}
          className="form-control"
          
        />
        </div>
        <div className="mb-4 col-4"> 
        <label for="bulletinImage" className="form-label">Image</label>
        <input
          placeholder="bulletinImage"
          id="bulletinImage"          
          type="file"
          onChange={(e) => SetBulletinImage(e.target.files[0])}
          accept="image/*"
          className="form-control"
        />
        </div>
        <div className="mb-4 col-3">
        <label for="bulletinAudio" className="form-label">Audio</label>
        <input
          placeholder="bulletinAudio"
          id="bulletinAudio"          
          type="file"
          onChange={(e) => SetBulletinAudio(e.target.files[0])}
          className="form-control"
        />
        </div> 
        

        <div className=" row offset-6 ">  
         <button  type="reset" className="btn btn-danger col-2 mx-3"> Annuler</button>   
          {btnvalider && <button  type="button" className="btn btn-success col-2" onClick={(e) => submit(e) } data-toggle="popover" title="Popover title"  data-content="toto"  > Valider</button> }    
          
        </div> 

        </div>
        
      </form>
      
    </div>
  );// fin return
  
  
}
}

export default Postformulairepays;
